import React/* , { useState } */ from 'react'
import { useFormik } from 'formik'
// import { connect } from "react-redux";
import { Link } from 'react-router-dom'
import * as Yup from 'yup'
import { injectIntl } from 'react-intl'
//import { useRouter } from '../../../hooks/useRouter'

const initialValues = {
	email: '',
}

function ForgotPassword(props) {
	//const router = useRouter()

	const { intl } = props
	const ForgotPasswordSchema = Yup.object().shape({
		email: Yup.string()
			.email('El formato del email no es válido')
			.min(3, 'Mínimo 3 caracteres')
			.max(50, 'Máximo 50 caracteres')
			.required(
				intl.formatMessage({
					id: 'AUTH.VALIDATION.REQUIRED_FIELD',
				})
			),
	})

	const getInputClasses = (fieldname) => {
		if (formik.touched[fieldname] && formik.errors[fieldname])
			return 'is-invalid'


		if (formik.touched[fieldname] && !formik.errors[fieldname])
			return 'is-valid'


		return ''
	}

	/* TODO */
	const formik = useFormik({
		initialValues,
		validationSchema: ForgotPasswordSchema,
		onSubmit: (values, { setStatus, setSubmitting }) => {
			console.log('%cTODO: forgot password', '🧠;background: lightpink; color: #444; padding: 3px; border-radius: 5px;')
		},
	})

	return (
		<div className="login-form login-forgot" style={{ display: 'block' }}>
			<div className="text-center mb-10 mb-lg-20">
				<h3 className="font-size-h1">¿Has olvidado la contraseña?</h3>
				<div className="text-muted font-weight-bold">
					Pídele a un administrador que te asigne una nueva.
				</div>
			</div>
			<form
				onSubmit={formik.handleSubmit}
				className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
			>
				{formik.status && (
					<div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
						<div className="alert-text font-weight-bold">
							{formik.status}
						</div>
					</div>
				)}
				<div className="form-group fv-plugins-icon-container">
					<input
						type="email"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							'email'
						)}`}
						name="email"
						{...formik.getFieldProps('email')}
					/>
					{formik.touched.email && formik.errors.email ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.email}</div>
						</div>
					) : null}
				</div>
				<div className="form-group d-flex flex-wrap flex-center">
					<button
						id="kt_login_forgot_submit"
						type="submit"
						className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
						disabled={formik.isSubmitting}
					>
						<span>Enviar</span>
						{formik.isSubmitting && <span className="ml-3 spinner spinner-white"/>}
					</button>
					<Link to="/auth">
						<button
							type="button"
							id="kt_login_forgot_cancel"
							className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
						>
							Volver
						</button>
					</Link>
				</div>
			</form>
		</div>
	)
}

export default injectIntl(/* connect(null, auth.actions) */(ForgotPassword))
